import TopMedia from './FooterCTA'

export default TopMedia
